<template>
    <span>
        {{ ini }}
    </span>
</template>

<script lant="ts">
import {defineComponent} from "vue";

export default defineComponent({
    name: "counterTable",
    props: {
        iniTime: {
            type: Number,
            require: true
        },
        time: {
            type: Number,
            require: true
        }
    },
    data() {
        return {
            ini: 0
        }
    },
    created() {
        const animate = setInterval(() => {
            this.ini++;
            if (this.ini >= this.iniTime) {
                clearInterval(animate)
            }
        }, this.time);
    }
})

</script>
